export const BUILD_TIME_EPO_EDIT_ENABLED = true;

export const isEpoEditEnabledSeller = (debugPanelEpoEditEnabledSeller: boolean): boolean =>
  BUILD_TIME_EPO_EDIT_ENABLED || debugPanelEpoEditEnabledSeller;
